import React from 'react';
import './Lawnex.css'
import { useTranslation } from 'react-i18next';
import lawnexLogo from '../../assest/images/lawnexLogo.svg'; // تأكد من مسار الصورة لديك
import screenshot1 from '../../assest/images/screen1.png'; 
import screenshot2 from '../../assest/images/screen2.png';
import { SectionHeader, SectionWrap, LawnexFitur } from '../../Components';

function LawnexSection() {
  const { t } = useTranslation();

  // مصفوفة الميزات القانونية لتطبيق لاونكس مدعومة بمفاتيح الترجمة وجلب الأيقونات برمجياً
  const features = [
  { icon: "🤖", titleKey: "aiConsultationTitle", descKey: "aiConsultationDesc" },
  { icon: "📚", titleKey: "lawLibraryTitle", descKey: "lawLibraryDesc" },
  { icon: "📄", titleKey: "contractTemplatesTitle", descKey: "contractTemplatesDesc" },
  { icon: "🏢", titleKey: "officeManagementTitle", descKey: "officeManagementDesc" },
  { icon: "🔍", titleKey: "smartSearchTitle", descKey: "smartSearchDesc" },
  { icon: "🔒", titleKey: "secureConfidentialTitle", descKey: "secureConfidentialDesc" }
  ];

  return (
    <section id="lawnex" className="premium-lawnex-section">
      <div className="lawnex-global-container">
        
        <div className='containerNew'>
        <SectionWrap>
        <div className="premium-badge animate-badge">
          <span>{t('lawnexLabel')}</span>
        </div>

        {/* هيدر القسم المطور مع اللوغو الزجاجي الفاخر */}
        <div className="lawnex-header">
          <div className="header-text-block">
            <h2 className="premium-section-title">{t('lawnexTitle')}</h2>
            <p className="lawnex-subtitle">
              {t('lawnexSubtitle')}
            </p>
          </div>
          <div className="lawnex-logo-display">
            <img src={lawnexLogo} alt="Lawnex Logo" />
            <div className="logo-brand-details">
              <span className="brand-name">LAWNEX</span>
              <span className="brand-tagline">LEGAL AI</span>
            </div>
          </div>
        </div>
        </SectionWrap>
        </div>
        
        {/* شبكة الميزات الست المضاءة بهندسة برمجية دقيقة */}
        <div className="features-grid containerNew">
          {features.map((feat, index) => (
            <div className="feature-card" key={index}>
              <span className="feature-icon">{feat.icon}</span>
              <h3 className="feature-title">{t(feat.titleKey, feat.defTitle)}</h3>
              <p className="feature-desc">{t(feat.descKey, feat.defDesc)}</p>
            </div>
          ))}
        </div>
        <LawnexFitur />
        <div className="mockup-showcase containerNew">
           <div className="mockup-phones">
            <div className="mockup-phone">
                <div className="phone-notch"></div>
                <img src={screenshot1} className="phone-screen-image" alt="Lawnex App Chat Screen" />
            </div>
            <div className="mockup-phone">
                <div className="phone-notch"></div>
                <img src={screenshot2} className="phone-screen-image" alt="Lawnex App Library Screen" />
            </div>
            </div>
          
          {/* نصوص وأزرار التحميل المباشرة الفخمة */}
          <div className="mockup-text">
            <h3>{t('downloadLawnex')}</h3>
            <p>
              {t('downloadLawnexDesc')}
            </p>
            
            <div className="app-store-btns">
              <a className="app-btn" href='https://play.google.com/store/apps/details?id=com.lawnex.app&pcampaignid=web_share'>
                <span className="app-btn-icon">▶</span>
                <div className="app-btn-text">
                  <div className="label">{t('getItOn')}</div>
                  <div className="name">Google Play</div>
                </div>
              </a>
              
              <a href="https://www.instagram.com/reel/DYAL52SIgx-/" class="app-btn" target="_blank" rel="noreferrer">
                <span className="app-btn-icon">🎬</span>
                <div className="app-btn-text">
                  <div className="label">{t('watchDownload')}</div>
                  <div className="name">{t('demoVideo')}</div>
                </div>
              </a>
            </div>
          </div>

        </div>

      </div>
    </section>
  );
}

export default LawnexSection;